import { Injectable } from '@angular/core';
import {Http} from "@angular/http";

@Injectable()
export class CountryService {

  constructor(private _http: Http) { }

  getCountries() {
      return this._http.get('assets/countries.json')
          .map(response => response.json())
  }
  getSelectCountries() {
      return this._http.get('assets/countries_select.json')
          .map(response => response.json())
  }

}



// WEBPACK FOOTER //
// ./src/app/country.service.ts